import { User } from '../models/user';

export class FetchUserSuccess {
    static readonly type = '[User] FetchUserSuccess';

    constructor(public payload: User) {}
}
